$component-class: 'dh-section';

// ── Base ──────────────────────────────────────────────────────────

.#{$component-class} {
  display: block;
  width: 100%;
}

// ── Container modifier (max-width + horizontal padding) ──────────

.#{$component-class}--container {
  @include dh-container;
}

// ── Vertical gap (padding-top / padding-bottom) ──────────────────

@each $name, $value in $spacings {
  .#{$component-class}--y-gap-#{$name} {
    padding-top: var(--spacing-#{$name});
    padding-bottom: var(--spacing-#{$name});
  }
}

.#{$component-class}--y-gap-none {
  padding-top: 0;
  padding-bottom: 0;
}

@each $name, $value in $spacings {
  .#{$component-class}--y-gap-sm-#{$name} {
    @include dh-sm {
      padding-top: var(--spacing-#{$name});
      padding-bottom: var(--spacing-#{$name});
    }
  }
}

.#{$component-class}--y-gap-sm-none {
  @include dh-sm {
    padding-top: 0;
    padding-bottom: 0;
  }
}

@each $name, $value in $spacings {
  .#{$component-class}--y-gap-md-#{$name} {
    @include dh-md {
      padding-top: var(--spacing-#{$name});
      padding-bottom: var(--spacing-#{$name});
    }
  }
}

.#{$component-class}--y-gap-md-none {
  @include dh-md {
    padding-top: 0;
    padding-bottom: 0;
  }
}

@each $name, $value in $spacings {
  .#{$component-class}--y-gap-lg-#{$name} {
    @include dh-lg {
      padding-top: var(--spacing-#{$name});
      padding-bottom: var(--spacing-#{$name});
    }
  }
}

.#{$component-class}--y-gap-lg-none {
  @include dh-lg {
    padding-top: 0;
    padding-bottom: 0;
  }
}
